import { AtSign, Code, Earth, SendHorizonal } from 'lucide-react';
import { Icon } from '../shared/Icon';
import { motion } from 'motion/react';

const footerAnimation = {
    initial: { y: 60 },
    whileInView: { y: 0 },
    viewport: { once: true },
    transition: { duration: 1.5 },
} as const;

const productLinks = ['Performance Laptops', 'Gaming Rigs', 'Pro Accessories', 'Software Licenses'] as const;
const companyLinks = ['Our Mission', 'Technical Blog', 'Certifications', 'Privacy Policy'] as const;

export const Footer = () => {
    return (
        <motion.footer
        initial={footerAnimation.initial}
        whileInView={footerAnimation.whileInView}
        viewport={footerAnimation.viewport}
        transition={footerAnimation.transition}
        className="px-15 py-10 bg-light-surface dark:bg-dark-bg border-t dark:border-dark-border border-light-border">
            <div className="flex flex-wrap justify-between gap-10">
                <div className="">
                    <h2 className="text-3xl dark:text-light-bg font-bold">SHINA <span className="text-primary">STORE</span></h2>
                    <p className="max-w-xs dark:text-secondary text-light-text-muted mt-5">Setting the standard for technical excellence in e-commerce. Your destination for premium hardware and visionary tech tools.</p>
                    <div className="flex gap-4 mt-5 text-light-text-muted">
                        <span className="p-2 bg-light-fg dark:bg-dark-surface dark:text-light-bg rounded-2xl"><Icon icon={Earth} /></span>
                        <span className="p-2 bg-light-fg dark:bg-dark-surface dark:text-light-bg rounded-2xl"><Icon icon={AtSign} /></span>
                        <span className="p-2 bg-light-fg dark:bg-dark-surface dark:text-light-bg rounded-2xl"><Icon icon={Code} /></span>
                    </div>
                </div>
                <div className="">
                    <h6 className="text-primary font-semibold tracking-[0.2em]">PRODUCTS</h6>
                    <ul className="mt-5 dark:text-secondary space-y-4">
                        {productLinks.map(item => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                </div>
                <div className="">
                    <h6 className="text-primary font-semibold tracking-[0.2em]">COMPANY</h6>
                    <ul className="mt-5 dark:text-secondary  space-y-4">
                        {companyLinks.map(item => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                </div>
                <div className="">
                    <h6 className="text-primary font-semibold tracking-[0.2em]">NEWSLETTER</h6>
                    <p className="dark:text-secondary ">Get early access to tech drops and exclusive pro-tier discounts.</p>
                    <div className="mt-5 flex gap-2 items-center">
                        <input type="email" className="max-w-xs w-full border-light-border border rounded-xl bg-light-bg dark:bg-dark-surface dark:border-dark-border px-4 py-3" />
                        <button className="bg-primary text-light-bg p-3 rounded-xl">
                            <Icon icon={SendHorizonal} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="border-t mt-5 border-light-border dark:border-dark-border  dark:text-secondary  text-light-text-secondary">
                <p className="mt-5">@ 2024 Shina Store. All hardware reserved</p>
            </div>
        </motion.footer>
    )
}
